var _style, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6C63FF;}\n\t.st1{opacity:0.7;fill:#F0F4F8;}\n\t.st2{fill:#2B365A;}\n\t.st3{fill:#B2B2B2;}\n\t.st4{fill:#6C63FF;stroke:#EFEFEF;stroke-miterlimit:10;}\n\t.st5{opacity:0.3;}\n\t.st6{fill:#DEDEDE;stroke:#263238;stroke-miterlimit:10;}\n\t.st7{fill:#6C63FF;stroke:#263238;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;stroke:#263238;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#263238;stroke-miterlimit:10;}\n\t.st10{fill:#ABABAB;stroke:#263238;stroke-miterlimit:10;}\n\t.st11{fill:#263238;stroke:#263238;stroke-miterlimit:10;}\n\t.st12{fill:#263238;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.7,117c-1.7-2.8-3.4-5.5-5.2-8.2c-24.3-35.7-64.7-60.1-104-71.2c-17.2-4.9-34.9-7.4-52.5-8 c-115.7-4.2-158.2,91.2-195.4,115.8C57.2,169.9,0,211.9,7.2,300.2c5.4,67.1,43.6,131.2,113.3,160.4c7.7,3.2,15.7,6,24.2,8.3 c15.7,4.3,32.7,7,51.1,7.9c52.7,2.3,95.5-10.4,137.3-42.3c9.7-7.4,19.4-15.8,32-16.7c9.2-0.7,17.9,2.6,8.3,11.5 c-11.3,10.4,1.7,30.9,30.4,16.7c47.8-23.8,67.5-75.1,76.7-127.3C491.9,254.5,486.4,174.8,451.7,117z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.7,117c-1.7-2.8-3.4-5.5-5.2-8.2c-24.3-35.7-64.7-60.1-104-71.2c-17.2-4.9-34.9-7.4-52.5-8 c-115.7-4.2-158.2,91.2-195.4,115.8C57.2,169.9,0,211.9,7.2,300.2c5.4,67.1,43.6,131.2,113.3,160.4c7.7,3.2,15.7,6,24.2,8.3 c15.7,4.3,32.7,7,51.1,7.9c52.7,2.3,95.5-10.4,137.3-42.3c9.7-7.4,19.4-15.8,32-16.7c9.2-0.7,17.9,2.6,8.3,11.5 c-11.3,10.4,1.7,30.9,30.4,16.7c47.8-23.8,67.5-75.1,76.7-127.3C491.9,254.5,486.4,174.8,451.7,117z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Space"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.2,460.5c-3.7,0-7.5-0.1-11.4-0.3c-16.7-0.7-32.7-3.2-47.5-7.3c-7.6-2.1-15-4.6-22-7.6 C66.6,420.8,28.4,366.5,23,300c-2.8-34.2,4.8-63,23.2-88.1c15.5-21.1,36.2-36.3,56.2-49.5c13.1-8.6,24.7-21.7,38.2-36.8 c31.8-35.5,71.3-79.8,143.5-79.8c2.2,0,4.5,0,6.7,0.1c17,0.6,33.4,3.1,48.6,7.4c39.1,11,74.3,34.9,93.9,63.8 c1.6,2.3,3.1,4.8,4.7,7.3c34.7,57.7,36.6,137.2,26.8,192.2c-9.7,54.6-27.6,89.4-56,108.2c-0.4-2.5-1.1-4.5-1.6-6 c-5-12.8-18-20.4-34.7-20.4c-1.4,0-2.8,0.1-4.2,0.2c-19.8,1.4-34.2,12.6-44.6,20.7c-0.9,0.7-1.8,1.4-2.7,2.1 C285.7,448.5,250.2,460.5,206.2,460.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Stars"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 362.5,
    cy: 100.9,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 441.1,
    cy: 180.2,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 116.8,
    cy: 402.6,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 402.5,
    cy: 398.5,
    r: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.5,60c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7 C247.3,57.3,248.5,58.5,248.5,60z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 221.8,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 400.2,
    cy: 104.4,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 86.9,
    cy: 371.3,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 430.6,
    cy: 352.1,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.2,416.3c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3C215.2,414,216.2,415,216.2,416.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.9,334.2c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3C95.9,331.8,96.9,332.9,96.9,334.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193.4,445.8c0,1.3-1,2.3-2.3,2.3s-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3S193.4,444.5,193.4,445.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.4,70.7c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3C326.4,68.4,327.4,69.4,327.4,70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M331.4,325.2c0,1.3-1,2.3-2.3,2.3s-2.3-1-2.3-2.3s1-2.3,2.3-2.3S331.4,323.9,331.4,325.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M438.3,234.7c0,1.3-1,2.3-2.3,2.3s-2.3-1-2.3-2.3s1-2.3,2.3-2.3S438.3,233.4,438.3,234.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 57.3,
    cy: 323.9,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 264.7,
    cy: 429.5,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 180.3,
    cy: 338.6,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.5,150.6c0,1.3-1,2.3-2.3,2.3s-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3S335.5,149.3,335.5,150.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Text_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M121.8,338.9v-49.1H62.2v-29.1l52-121.5h39.7v123.5h20.5v27.1h-20.5v49.1H121.8z M90.8,262.7h31.1v-86.8 L90.8,262.7z M244.3,341.8c-11.7,0-21.3-2.5-29-7.4c-7.6-4.9-13.4-11.7-17.3-20.5c-3.9-8.7-5.8-18.7-5.8-30.1v-88.5 c0-11.7,1.8-21.9,5.5-30.7c3.7-8.8,9.4-15.7,17-20.6c7.6-4.9,17.5-7.4,29.5-7.4c12,0,21.8,2.5,29.5,7.4c7.6,4.9,13.3,11.8,17,20.6 c3.7,8.8,5.5,19,5.5,30.7v88.5c0,11.3-1.9,21.4-5.8,30.1c-3.9,8.7-9.6,15.5-17.3,20.5C265.7,339.4,256,341.8,244.3,341.8z  M244.3,312.5c5.1,0,8.9-1.6,11.3-4.7c2.5-3.1,4.1-6.9,4.9-11.3c0.8-4.4,1.2-8.8,1.2-13.1v-87.5c0-4.6-0.4-9.2-1.1-13.7 c-0.7-4.5-2.3-8.3-4.8-11.5c-2.5-3.1-6.3-4.7-11.6-4.7c-5.3,0-9.1,1.6-11.6,4.7c-2.5,3.1-4.1,6.9-4.8,11.5 c-0.7,4.5-1.1,9.1-1.1,13.7v87.5c0,4.3,0.4,8.6,1.4,13.1c0.9,4.4,2.6,8.2,5.1,11.3C235.7,310.9,239.4,312.5,244.3,312.5z  M377.7,338.9v-49.1h-59.7v-29.1l52-121.5h39.7v123.5h20.5v27.1h-20.5v49.1H377.7z M346.7,262.7h31.1v-86.8L346.7,262.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.4,362.6v5.9h9.6v5.5h-9.6v6.4h10.8v5.7h-18v-29.4h18v5.7H143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.9,386.2l-6.1-11.1h-1.7v11.1h-7.2v-29.4h12c2.3,0,4.3,0.4,5.9,1.2s2.9,1.9,3.7,3.3 c0.8,1.4,1.2,3,1.2,4.7c0,2-0.6,3.7-1.7,5.2c-1.1,1.5-2.7,2.6-4.9,3.3l6.8,11.6H173.9z M166.1,370.1h4.4c1.3,0,2.3-0.3,2.9-1 c0.7-0.6,1-1.5,1-2.7c0-1.1-0.3-2-1-2.6c-0.7-0.6-1.6-1-2.9-1h-4.4V370.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M201.1,386.2l-6.1-11.1h-1.7v11.1h-7.2v-29.4h12c2.3,0,4.3,0.4,5.9,1.2s2.9,1.9,3.7,3.3 c0.8,1.4,1.2,3,1.2,4.7c0,2-0.6,3.7-1.7,5.2c-1.1,1.5-2.7,2.6-4.9,3.3l6.8,11.6H201.1z M193.3,370.1h4.4c1.3,0,2.3-0.3,2.9-1 c0.7-0.6,1-1.5,1-2.7c0-1.1-0.3-2-1-2.6c-0.7-0.6-1.6-1-2.9-1h-4.4V370.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M219.7,384.6c-2.3-1.3-4.1-3.1-5.5-5.4s-2-4.9-2-7.8c0-2.9,0.7-5.4,2-7.7c1.4-2.3,3.2-4.1,5.5-5.4 c2.3-1.3,4.8-1.9,7.6-1.9s5.3,0.6,7.6,1.9c2.3,1.3,4.1,3.1,5.4,5.4c1.3,2.3,2,4.9,2,7.7c0,2.9-0.7,5.5-2,7.8s-3.2,4.1-5.4,5.4 s-4.8,1.9-7.6,1.9S222,385.9,219.7,384.6z M232.9,377.6c1.4-1.6,2.1-3.6,2.1-6.2c0-2.6-0.7-4.7-2.1-6.2c-1.4-1.5-3.3-2.3-5.6-2.3 c-2.4,0-4.3,0.8-5.7,2.3c-1.4,1.5-2.1,3.6-2.1,6.2c0,2.6,0.7,4.7,2.1,6.2c1.4,1.5,3.3,2.3,5.7,2.3 C229.7,380,231.5,379.2,232.9,377.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M261.3,386.2l-6.1-11.1h-1.7v11.1h-7.2v-29.4h12c2.3,0,4.3,0.4,5.9,1.2s2.9,1.9,3.7,3.3 c0.8,1.4,1.2,3,1.2,4.7c0,2-0.6,3.7-1.7,5.2c-1.1,1.5-2.7,2.6-4.9,3.3l6.8,11.6H261.3z M253.4,370.1h4.4c1.3,0,2.3-0.3,2.9-1 c0.7-0.6,1-1.5,1-2.7c0-1.1-0.3-2-1-2.6c-0.7-0.6-1.6-1-2.9-1h-4.4V370.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M303.6,371c-0.8,1.4-2,2.5-3.6,3.4c-1.6,0.9-3.6,1.3-6,1.3h-4.4v10.5h-7.2v-29.4H294c2.3,0,4.3,0.4,5.9,1.2 c1.6,0.8,2.8,1.9,3.6,3.3c0.8,1.4,1.2,3.1,1.2,4.9C304.8,368,304.4,369.6,303.6,371z M296.5,369c0.7-0.6,1-1.5,1-2.7 s-0.3-2.1-1-2.7c-0.7-0.6-1.7-1-3.1-1h-3.9v7.4h3.9C294.8,370,295.8,369.7,296.5,369z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M326.8,381h-11l-1.8,5.2h-7.5l10.6-29.4h8.3l10.6,29.4h-7.6L326.8,381z M325,375.5l-3.6-10.7l-3.6,10.7H325z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M358.8,366.1c-0.5-1-1.3-1.7-2.3-2.2s-2.2-0.8-3.5-0.8c-2.3,0-4.2,0.8-5.6,2.3c-1.4,1.5-2.1,3.5-2.1,6.1 c0,2.7,0.7,4.8,2.2,6.3c1.5,1.5,3.5,2.3,6,2.3c1.8,0,3.2-0.4,4.5-1.3c1.2-0.9,2.1-2.2,2.7-3.8h-9.1v-5.3h15.6v6.6 c-0.5,1.8-1.4,3.4-2.7,5s-2.9,2.8-4.8,3.7c-2,0.9-4.2,1.4-6.6,1.4c-2.9,0-5.5-0.6-7.8-1.9c-2.3-1.3-4-3-5.3-5.3 c-1.3-2.3-1.9-4.8-1.9-7.7c0-2.9,0.6-5.5,1.9-7.8c1.3-2.3,3-4,5.3-5.3c2.3-1.3,4.8-1.9,7.7-1.9c3.5,0,6.5,0.9,8.9,2.6 c2.4,1.7,4,4.1,4.8,7.1H358.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M378.3,362.6v5.9h9.6v5.5h-9.6v6.4h10.8v5.7h-18v-29.4h18v5.7H378.3z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.7,285.1c0,0,0.1,0.1,0.1,0.1c0.2,0.1,0.4,0.3,0.6,0.4c0,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.3 c0.1,0,0.1,0.1,0.2,0.1c0.3,0.1,0.5,0.2,0.8,0.3c0,0,0.1,0,0.1,0c0.3,0.1,0.5,0.1,0.8,0.2c0.1,0,0.2,0,0.3,0 c0.4,0,0.7,0.1,1.1,0.1c0,0,0,0,0,0c1.4,0.1,2.8-0.2,4.1-0.8c0.7-0.3,1.4-0.6,2-1c0.4-0.3,0.9-0.6,1.3-0.9 c0.2-0.2,0.4-0.3,0.6-0.5c0.4-0.4,0.8-0.7,1.2-1.1c3.3-3.6,5.3-9.3,3.6-16c-0.4-1.7-0.8-3.2-1.3-4.7c-0.8-2.5-1.6-4.8-2.5-6.8 c-0.2-0.5-0.5-1.1-0.7-1.6c-0.6-1.2-1.2-2.3-1.9-3.4c-0.4-0.7-0.9-1.3-1.4-2c-1.2-1.5-2.4-2.7-3.7-3.7c-0.3-0.2-0.7-0.5-1-0.7 c-0.1-0.1-0.2-0.1-0.3-0.1l-7.4,17.3V280c0.7,2,1.2,3.8,2.4,5c0,0,0,0,0,0C320.6,285,320.6,285.1,320.7,285.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.4,280v-34.3c-1,0-1.9,0.1-2.7,0.1c0-1.1,0.2-8.3-1.8-16.1c-0.1-6.9-2.9-13.1-7.4-17.4c-0.5-6.6-4.2-14.4-8.3-19.8 c0.1,0,0.2,0,0.3,0c1.7-0.2,2.7-2.3,3.4-5.8c0.1-0.5,0.2-1,0.2-1.4c1.3-0.9,2.9-2.2,3.7-3.7c0.4-0.8,0.8-2.1,1-3.6 c1.3-0.8,3.1-2.1,4.9-4.1c1.3-1.4,2.2-3.4,2.5-5.6c-0.4-1.3-0.9-2.5-1.4-3.7c-2.2-5.3-5.2-9.8-8.8-13.7c-1-0.5-2.2-1-3.4-1.3 c-1.1-0.3-2.2-0.4-3.3-0.5c-3.1-0.6-9.5-1.7-18.4-1.9c-3-0.1-5.7-0.1-8.1,0.1c-2-0.9-4.3-1.3-6.6-1c-1.4,0.2-2.7,0.5-4,1.1 c-3.8-1-7.7-1.3-10.8-0.9c-0.8,0.1-1.5,0.2-2.2,0.3c0-0.4-0.1-0.8-0.1-1.1c-0.1-0.7-0.2-1.5-0.3-2.2c0.1-1.3,0.1-2.7,0-4 c-3.6,1.2-7,2.7-10,4.6c-7.6,4.9-13.3,11.8-17,20.6c-3.7,8.8-5.5,19-5.5,30.7v8.8c3.6,4.6,7.9,9.8,10.8,11.8 c0.2,0.2,0.4,0.4,0.6,0.6c0.2,3.4,0.8,11.2,2.3,13.8c0,0-1.2,4.1,0.8,6.2c-0.6,4.6-1.4,16.2,3.4,27.6c3.7,8.9,10.1,13.6,16.6,15.2 v-83.5c0-4.6,0.4-9.2,1.1-13.7c0.7-4.5,2.3-8.3,4.8-11.5c2.5-3.1,6.3-4.7,11.6-4.7c5.3,0,9.1,1.6,11.6,4.7 c2.5,3.1,4.1,6.9,4.8,11.5c0.7,4.5,1.1,9.1,1.1,13.7v87.5c0,1.5-0.1,3-0.2,4.5c0.1,0.3,0.1,0.6,0.2,0.8c0,0,0,0,0,0c0,0,0,0,0,0 c0.1,0.3,0.2,0.6,0.3,0.8c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.4,0.3,0.5c0,0,0.1,0.1,0.1,0.1c0.1,0.2,0.3,0.3,0.4,0.5c0,0,0,0,0,0 c0.2,0.1,0.3,0.3,0.5,0.4c0,0,0.1,0.1,0.1,0.1c0.2,0.1,0.3,0.2,0.5,0.2c0,0,0.1,0,0.1,0c0.2,0.1,0.4,0.2,0.7,0.2 c0.1,0,0.1,0,0.2,0c0.2,0.1,0.4,0.1,0.6,0.2c0.1,0,0.2,0,0.2,0.1c0.2,0.1,0.5,0.1,0.7,0.2c3.6,0.8,9.8-4.1,11.4-9 c0.3-1,0.5-2.1,0.7-3.3c0.2,0,0.4-0.1,0.6-0.1C282.6,280.4,289.2,281.3,296.4,280z M273.4,189.3 C273.4,189.3,273.4,189.3,273.4,189.3c0-0.2,0-0.3,0-0.5C273.4,189,273.4,189.2,273.4,189.3z M273.7,186.8c0.1-0.5,0.1-1,0.2-1.5 l0,0C273.9,185.8,273.8,186.3,273.7,186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.9,207.3c-1.3,3.2-2.4,6.1-3,7.8c-1.8,5.2-3.8,11-3.7,14.3c0,3.4,2.1,7.6,3.7,7.8c1.6,0.1,2.8-0.9,3-3.2V207.3z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M269.1,217.2c0,0,1,7.5,0.9,15.1c-0.1,7.6,1.7,7.8,5.3,8.6s9.8-4.1,11.4-9c1.6-4.9,1.4-14.5,1.4-14.5 L269.1,217.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M285.7,226.3c-0.2,3.4-1.2,8.8-6.2,11.4c-4.2,2.3-7.9,0.3-9-0.4c0.7,2.6,2.4,2.9,4.9,3.5 c3.6,0.8,9.8-4.1,11.4-9c1.6-4.9,1.4-14.5,1.4-14.5l-2.2,0C285.9,219.9,285.8,224.1,285.7,226.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M251.9,224.4c0,0,6-0.1,14.1-3.1c8.1-3,17.3-9.8,15.3-16.5c-2-6.7-12.6-8.5-16.8-8.1c-4.2,0.5-9,1.7-9,1.7 S256.6,217.1,251.9,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M248,227.1c0,0,5.4-1.1,8.6-5.3c3.2-4.2,4.4-11.1,2.7-15.7C257.5,201.5,248,227.1,248,227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.8,183.2c0,0-3.1,15,3,29.7c6.2,14.7,19.6,18.2,29.1,14.1s11.7-17.3,11.8-26.2c0.1-8.8-0.2-12.9-0.2-12.9 S227.8,191.1,215.8,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M214.7,179.1c0,0-1.4,4.9,1.4,6.7c2.8,1.8,17.6,10.5,35,7.1c9.8-1.8,7.6-4.7,7.4-6.3 C258.4,185.1,214.7,179.1,214.7,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M212.3,163.7c0,0,0.4,12.1,2.4,15.5c2,3.3,27.8,13.4,40.9,10.6c13.1-2.8,34.4-14.5,37-23.1 c2.6-8.6-4.2-22.1-10.5-28.6s-9.1-7.8-9.1-7.8s-15.6,20.8-35,27.6C218.6,164.8,212.3,163.7,212.3,163.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M315.2,194.3c0,0,13.7-5.4,19.2-2.1c5.5,3.3,9.7,11,12.5,22.8c2.9,11.9-5.5,20.6-12.8,20.3 c-7.3-0.3-6-5-8.8-9.8c-2.8-4.8-6.3-7.6-6.5-8.1C318.6,216.9,322,201.7,315.2,194.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M334.4,192.3c-1.5-0.9-3.5-1.1-5.7-1c2.8,2.1,8.3,7.1,11.8,16.6c5,13.2,2.7,20.2,0.2,22.8 c-2.5,2.6-7.9,3.5-10.2,3.2c-0.4,0-0.8-0.1-1.3-0.2c1,1,2.5,1.6,5,1.7c7.3,0.3,15.7-8.4,12.8-20.3 C344.1,203.2,339.9,195.5,334.4,192.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M286.2,228c0,0,12.9,3.7,25-1.1c12-4.8,19.1-12.8,16.4-22.6c-2.7-9.8-7.6-10.1-18.6-10 c-10.9,0.1-13.1,1.1-13.1,1.1S295.5,223,286.2,228z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.396496e-02 -0.9956 0.9956 9.396496e-02 73.8776 439.5362)",
    className: "st7",
    cx: 278.4,
    cy: 179.2,
    rx: 24,
    ry: 22.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.397823e-02 -0.9956 0.9956 9.397823e-02 52.2255 471.496)",
    className: "st7",
    cx: 285.2,
    cy: 207.1,
    rx: 21.7,
    ry: 20.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M302.4,194.7c0,0,0.9-19.3-8.6-30c-9.5-10.6-30.9-1.9-34.5,14c-3.6,15.9,4,39.8,13.8,46 c9.9,6.2,18.2,0.1,23.8-8.4C302.5,207.7,302.4,194.7,302.4,194.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M168.8,140.5c0,0-7.5,18.1-9.3,23.3c-1.8,5.2-3.8,11-3.7,14.3c0,3.4,2.1,7.6,3.7,7.8c1.6,0.1,2.8-0.9,3-3.2 c0.2-2.3,0.1-3.2,1.3-4.5c1.1-1.2,4.7-3.7,5.2-3.9c0.5-0.2,0.8,1.5-0.3,3.4c-1.1,1.9-3.5,3.6-2,5.5c1.5,1.9,4.4-0.3,6-1.9 c1.6-1.6,3.2-4.4,3.9-7.1c0.7-2.8,0.3-8.7,0.3-8.7l13.2-12.5C190.2,152.9,172.7,150.8,168.8,140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M169.7,176.1c0,0-0.2,2.6,4.6,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M157,174c0,0,1.3,5,6.9,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.5,180.9c0,0,3.3,2.5,5.7-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M163.3,156.1c0,0-0.4,9.9,13.7,9.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M172.6,135.1c0,0-3.5,0.1-3.7,5.4c-0.2,5.3,4,13.5,12.2,14.8c8.2,1.4,13.2-3.5,14.7-7.5 C197.2,143.8,178.2,131.9,172.6,135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M181.7,120.7c0,0-8.6,10.4-10.1,15.7c-1.5,5.3,2.3,15,11.8,16.2c9.6,1.2,15.3-6.8,15.3-6.8L181.7,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M186.7,112.3c0,0-6.2,5.2-6.6,13.7c-0.4,8.5,7.4,18.2,17.6,17.3C207.8,142.3,195.1,111.9,186.7,112.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.9,118.6c0,0-4.5,5.5-1.9,14.6c2.6,9.2,9.1,14.2,9.1,14.2s12.5,18,17.8,20.8c5.3,2.8,14.6,2.9,33.4-4.8 c18.9-7.7,26.3-18.9,29.2-24.6c2.9-5.8-14.1-32.3-19.9-36.1c-5.9-3.8-13.5-5.1-19.1-4.5c-5.5,0.6-10.7,2-10.7,2L190.9,118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M187.6,115.6c0,0-4.5,5.5-1.9,14.6c2.6,9.2,9.1,14.2,9.1,14.2s12.5,18,17.8,20.8c5.3,2.8,14.6,2.9,33.4-4.8 s26.3-18.9,29.2-24.6s-14.1-32.3-19.9-36.1c-5.9-3.8-13.5-5.1-19.1-4.5c-5.5,0.6-10.7,2-10.7,2L187.6,115.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.274 -0.9617 0.9617 0.274 55.4651 268.3768)",
    className: "st7",
    cx: 205.5,
    cy: 97.5,
    rx: 28.5,
    ry: 28.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6193 -0.7852 0.7852 0.6193 5.9806 192.4056)",
    className: "st10",
    cx: 201.4,
    cy: 90,
    rx: 32.2,
    ry: 32.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M223.5,94.6c0.3-0.7,0.8-1.9,0.6-3.4c-0.2-2.4-2.9-6.9-4-8.1s-2.9,0.2-2.9,0.2l-2-3.6 c-4.8-8.7-15.7-11.8-24.4-7c-8.7,4.8-11.8,15.7-7,24.4l4.1,7.4l-2.3-3.8c0,0-2.1,0.7-1.7,2.3c0.4,1.6,2.8,6.3,4.7,7.7 c1.4,1,2.8,1.2,3.5,1.3l5.5,9.8c2.4,0.3,4.8,0.3,7.2,0c10.8-1.2,19.8-7.6,24.7-16.5L223.5,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M215,85.6c-3.6-6.5-11.9-8.9-18.4-5.3l-2.5,1.4c-6.5,3.6-8.9,11.9-5.3,18.4l12.3,22.1c1.2,0,2.5,0,3.7-0.2 c9.6-1,17.8-6.2,22.9-13.6L215,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M200,99c0.5,0.8,0.4,1.7-0.1,2c-0.5,0.3-1.3-0.2-1.7-1c-0.5-0.8-0.4-1.7,0.1-2 C198.7,97.7,199.5,98.1,200,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M210.1,93.3c0.5,0.8,0.4,1.7-0.1,2c-0.5,0.3-1.3-0.2-1.7-1c-0.5-0.8-0.4-1.7,0.1-2 C208.9,92,209.7,92.5,210.1,93.3z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "205.1,94.6 210.4,101.1 205.6,103.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M212.9,106.5c0.5,0.8,0.2,1.9-0.7,2.3c-0.8,0.5-1.9,0.2-2.3-0.7c-0.5-0.8-0.2-1.9,0.7-2.3 C211.4,105.4,212.4,105.7,212.9,106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M192.9,97.8c0,0,0.8-3.2,5-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M204.4,90.4c0,0,1.1-3.4,5.5-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M207.4,117.2c0,0,3.5,1,6,0.5c2.5-0.5,4.5-1.8,5.4-3c0.9-1.2,2.2-5.1,2.2-5.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M177.7,108.6c-1.9-17.7,10.8-33.5,28.5-35.5c10.2-1.1,19.8,2.7,26.5,9.5c-3.7-15.6-18.4-26.4-34.8-24.6 c-17.7,1.9-30.4,17.8-28.5,35.5c0.8,7.5,4.1,14,9,19C178.1,111.3,177.9,110,177.7,108.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9942 -0.108 0.108 0.9942 -10.5418 27.9395)",
    className: "st7",
    cx: 252.7,
    cy: 111.3,
    rx: 14.5,
    ry: 16.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M286,98.4c0,0-7.8-2.1-20.4-2.4c-12.6-0.3-20.1,0.9-22.5,7.2c-2.4,6.3-1.9,16.5,5.9,19.8 c4.3,1.9,10.7,0.8,15.4-0.3c4.6-1.1,16-5.8,19.6-11.5C287.7,105.5,287.7,101,286,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.3,108c0,0-4.2-7.5-12-9.6c-7.8-2.1-14.9,3-18.2,8c-3.2,5-1.8,6.6-1.8,6.6s11.4-5.7,17.3-6.8 C290.6,105.2,299.3,108,299.3,108z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M267,118.1c0,0-1.8-5.3,5.6-12.1c7.4-6.8,21-4.4,25.4,0.2c4.4,4.6,3.9,12.6,0.4,16.5c-3.5,3.9-7,5.1-7,5.1 S284.5,116.1,267,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M260.9,128.4c0,0,2.8-7.5,6.2-10.3c3.3-2.9,13.3-4.1,20.7-1.5c7.4,2.6,6.1,11.1,4.7,13.8 c-1.4,2.7-5.6,4.8-5.6,4.8L260.9,128.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M261.7,127.2c0,0-1.5,0.3-3,1.9c-1.5,1.6-2,2.3-5,4c-3,1.7-6.2,1.8-5.1,5c1.2,3.2,5.6,2.8,7.8,2.2 c2.2-0.5,3.1-1.3,4.8-2.6c1.7-1.3,2.9-10.3,3-10.7C264.3,126.6,261.7,127.2,261.7,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M269.7,124.2c0,0-4.5-1.1-6.6,0.7c-2.2,1.8-2,8.6-1.8,12.8c0.2,4.2,1.7,7.5,3.3,8.1 c1.6,0.5,3.2,0.2,3.9-0.4c0.6-0.6,0-6.7,0.4-11.7C269.2,128.8,269.7,124.2,269.7,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M269.7,124.2c0,0-2,4.8-2.6,9.8c-0.6,5,2.1,11.7,3.2,12.3s4,0.4,4.6-1.1c0.7-1.5,0.2-6.5,0.3-9.4 c0.1-2.9,1.5-9.3,1.3-11.2C276.2,122.7,271.8,122.5,269.7,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M276.4,124.6c0,0,2.7-1.3,4.6-0.2c1.9,1.1,2.4,3.9,2.1,5.4c-0.3,1.4-1.2,9.9-1.8,12c-0.6,2-2.2,3-3.5,2.9 c-1.3-0.1-2.1-1.7-2.3-3.5c-0.2-1.8-0.4-5.3-0.4-5.3L276.4,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M283.1,127.1c0,0,3.6,0.9,4.7,1.6c1.1,0.7,1.5,3.1,0.7,6.6c-0.7,3.6-1.8,5.7-3.4,5.8c-1.7,0.2-3-1.9-3-3.2 C282.1,136.8,283.5,130,283.1,127.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M235.7,129.8c2.3,3.6,1.5,8.2-1.8,10.2c-3.2,2-7.7,0.7-9.9-3c-2.3-3.6-1.5-8.2,1.8-10.2 C229,124.9,233.4,126.2,235.7,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M218,142.1c1.6,2.5,1,5.8-1.2,7.2c-2.3,1.4-5.4,0.5-7-2.1c-1.6-2.5-1-5.8,1.2-7.2 C213.3,138.6,216.4,139.5,218,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M232.5,148.2c1.6,2.5,1,5.8-1.2,7.2c-2.3,1.4-5.4,0.5-7-2.1c-1.6-2.5-1-5.8,1.2-7.2 C227.8,144.7,230.9,145.6,232.5,148.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.4ae9f9473f26514d35cecd136a7af5f4.svg";
export { ForwardRef as ReactComponent };